module.exports = __webpack_public_path__ + "NorthernTunaCommon/react/images/cardBrands/googlePayMark.png";